export default "__VITE_ASSET__DD$TWKqj__"